import { render } from "./MessageDialog.vue?vue&type=template&id=1f40aa9b"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"

import "./MessageDialog.vue?vue&type=style&index=0&id=1f40aa9b&lang=css"

import exportComponent from "/codebuild/output/src3657311707/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__